/* eslint-disable eqeqeq */
import React, { PureComponent } from "react"
import PropTypes from "prop-types"

import ImageUploader from "../ImageUploader/index"
import QualificationUploader from "./QualificationUploader"
import SubIndustryDetail from "./SubIndustryDetail"
import $ from "jquery"

import { Checkbox } from "@tencent/spaui"

/**
 * @class
 */
class IndustryDetail extends PureComponent {
  constructor(props) {
    super(props)

    this.init = true
    const newState = this.initState(props)
    this.init = false

    this.state = {
      ...newState,
    }
    this.onChangeSubIndustry = this.onChangeSubIndustry.bind(this)
    this.onChangeHasAddtionalCheck = this.onChangeHasAddtionalCheck.bind(this)
    this.onAskDeleteOtherQual = this.onAskDeleteOtherQual.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const oldId = this.props.data.industry_id
    const newId = nextProps.data.industry_id
    let newState

    // 行业变化时，也需要重新设置上层 hasAdditionalChecked 的值
    if (oldId != newId) {
      this.init = true
      newState = this.initState(nextProps)
      this.init = false
    } else {
      newState = this.initState(nextProps)
    }

    this.setState({
      ...newState,
    })
  }

  // 获取业务范围数据、是否有补充资质、补充资质数据、补充资质是否checked
  initState(props) {
    const subIndustriesCheckData = []
    let subIndustryName,
      thirdPartyIndex,
      addtionalQualData = {}, // 其他资质
      hasAdditional = false,
      hasAdditionalChecked = false

    const businessRange = props.data.business_range || []

    // 业务范围
    businessRange.map((item) => {
      // 过滤B001资质
      if (this.isAdditional(item.business_range_id)) {
        hasAdditional = true
        addtionalQualData.industry_id = item.business_range_id
        addtionalQualData.certification_group = item.certification_group

        for (let i in addtionalQualData.certification_group) {
          for (let j in addtionalQualData.certification_group[i].certification_codes) {
            let images = addtionalQualData.certification_group[i].certification_codes[j].images
            if (images && images.length > 0 && images[0].data && images[0].data.length > 0) {
              hasAdditionalChecked = true
              break
            }
          }

          // 只有初始化的时候需要改变这个值
          if (this.init) {
            props.onCheckHasAddtionalCheck(hasAdditionalChecked)
            break
          }
        }
      } else {
        subIndustryName = item.business_range_name || ""

        subIndustriesCheckData.push({
          name: subIndustryName.replace(/^(是否是|是否)/g, ""),
          id: item.business_range_id,
        })
      }

      return true
    })

    // 第三方资质放到最后显示
    subIndustriesCheckData.forEach((item, idx) => {
      if (this.isThirdParty(item.id)) {
        thirdPartyIndex = idx
      }
    })

    if (typeof thirdPartyIndex == "number") {
      subIndustriesCheckData.push(subIndustriesCheckData.splice(thirdPartyIndex, 1)[0])
    }

    if (this.init) {
      return {
        hasAdditional,
        addtionalQualData,
        hasAdditionalChecked,
        subIndustriesCheckData,
      }
    } else {
      return {
        hasAdditional,
        addtionalQualData,
        subIndustriesCheckData,
      }
    }
  }

  /**
   * 改变业务范围的回调
   *
   * @param      {string}   val        The value
   * @param      {boolean}  isChecked  Indicates if checked
   */
  onChangeSubIndustry(val, isChecked) {
    const props = this.props
    const checkedSubIndus = $.extend(true, [], props.checkedSubIndustries)

    if (isChecked) {
      if (checkedSubIndus.indexOf(val) == -1) {
        checkedSubIndus.push(val)
      }
    } else {
      const idx = checkedSubIndus.indexOf(val)
      if (idx > -1) {
        checkedSubIndus.splice(idx, 1)
      }
    }
    this.props.onChangeCheckedSubIndustries(checkedSubIndus)
  }

  /**
   * 改变是否有补充资质的勾选
   */
  onChangeHasAddtionalCheck(event) {
    this.setState({ hasAdditionalChecked: event.target.checked })
    this.props.onCheckHasAddtionalCheck(event.target.checked)
  }

  // 是否是补充资质
  isAdditional(value) {
    const urlRegex = /^-\w*22$/g
    return urlRegex.test(value)
  }

  // 是否是第三方资质
  isThirdParty(value) {
    const urlRegex = /^-\w*21$/g
    return urlRegex.test(value)
  }

  /**
   * 生成业务范围对应的资质模块
   */
  genSubQualComp() {
    let id, subQualifications

    const res = []
    const props = this.props
    const checkedSubIndus = props.checkedSubIndustries
    const businessRange = this.props.data.business_range

    for (let j in checkedSubIndus) {
      for (let i in businessRange) {
        id = businessRange[i].business_range_id
        if (id == checkedSubIndus[j]) {
          if (!this.isAdditional(id)) {
            subQualifications = this.genQualificationComponents(businessRange[i].business_range_id, businessRange[i].certification_group)
            res.push(
              <div key={i} className="check-in-line">
                <span className="tt">上传文件</span>
                <div>{subQualifications}</div>
                {/* <p className="tips">{businessRange[i].business_range_name.replace(/^(是否是|是否)/g, '')}</p> */}
              </div>
            )
          }
        }
      }
    }

    return res
  }

  genQualificationComponents(industry_id, certification_group, hasLabel = true) {
    const { imageUploaderProps, qualificationUploaderProps } = this.props
    const data = certification_group
    const compArr = []
    if (!Array.isArray(data)) {
      return
    }

    for (let i = 0; i < data.length; i++) {
      compArr.push(
        <QualificationUploader
          key={i}
          {...qualificationUploaderProps}
          imageUploaderProps={imageUploaderProps}
          data={data[i]}
          industry_id={industry_id}
          idx={i}
          hasLabel={hasLabel}
          error={this.props.error}
          onUploaderFileChange={this.props.onUploaderFileChange}
          onUploaderFileDelete={this.props.onUploaderFileDelete}
          onChangeChosen={this.props.onChangeOptionalQualficationChosenVal}
          onChangeMultiple={this.props.onChangeMultiple}
          approvalStatusDisableEdit={this.props.approvalStatusDisableEdit}
        />
      )
    }

    return (
      <div className="check-in-line">
        <div className="auto-info-des auto-info-des-upimg">{compArr}</div>
      </div>
    )
  }

  onAskDeleteOtherQual(name) {
    console.log(name)
  }

  render() {
    const { imageUploaderProps = {}, otherQualificationsConfig = {}, disabledAddtionalQaulification = false, disabledBussinessRange = false } = this.props
    const data = this.props.data
    let otherQualsComp = []
    const otherQualifications = []
    const props = this.props

    // 行业资质
    const qualificationComp = this.genQualificationComponents(data.industry_id, data.certification_group)
    // 业务范围资质
    const subQualComp = this.genSubQualComp()

    // 补充资质
    const addtionalComp =
      this.state.hasAdditional && !disabledAddtionalQaulification ? (
        <div className="check-in-line">
          <Checkbox name="addtional_check" className="check" label={"需上传补充资质，如未完整上传的多页资质等"} checked={this.state.hasAdditionalChecked || false} onChange={this.onChangeHasAddtionalCheck} />
        </div>
      ) : (
        ""
      )

    const addtionalQuals = this.state.hasAdditionalChecked && !disabledAddtionalQaulification ? this.genQualificationComponents(this.state.addtionalQualData.industry_id, this.state.addtionalQualData.certification_group, false) : ""

    // 其他资质
    for (let i in props.otherQualifications) {
      otherQualifications.push({ url: props.otherQualifications[i].url, id: props.otherQualifications[i].id })
    }

    if (otherQualifications.length > 0) {
      otherQualsComp = (
        <div className="check-in-line">
          <span className="tt">其他资质</span>
          <div className="form-group">
            <div className="auto-info-des auto-info-des-upimg">
              <ImageUploader {...imageUploaderProps} {...otherQualificationsConfig} fileId={"other_qulifications"} limit={0} data={otherQualifications} enlargeable={false} onFileDelete={(name) => this.onAskDeleteOtherQual(name)}>
                <p>
                  点击上传资质证件
                  <br />
                  {this.isSupportH5 ? "或把图片拖拽到此处" : ""}
                </p>
                <span className="des">(jpg/png,小于5MB)</span>
              </ImageUploader>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div>
        <SubIndustryDetail
          disabled={disabledBussinessRange}
          data={this.state.subIndustriesCheckData}
          checkedSubIndustries={this.props.checkedSubIndustries || []}
          onChangeSubIndustry={this.onChangeSubIndustry}
          subQualComp={subQualComp}
          otherQualsComp={otherQualsComp}
          addtionalComp={addtionalComp}
          addtionalQuals={addtionalQuals}
        />
        <div className="auto-infolist auto-infolist-tt-ver">
          <label className="auto-info-tt">资质证件</label>
          {qualificationComp}
        </div>
      </div>
    )
  }
}

IndustryDetail.propTypes = {
  error: PropTypes.bool, // show error msg or not
  uid: PropTypes.string,
  data: PropTypes.object.isRequired, // industry data
  otherQualifications: PropTypes.array, // 其他资质
  checkedSubIndustries: PropTypes.array, // 选中的业务范围
  onChangeCheckedSubIndustries: PropTypes.func, // 修改业务范围checkbox选择
  onUploaderFileChange: PropTypes.func, // uplode file change event cb
  onUploaderFileDelete: PropTypes.func, // uplode file delete event cb
  onChangeOptionalQualficationChosenVal: PropTypes.func, // 修改N选一资质组件的radio选择
  onCheckHasAddtionalCheck: PropTypes.func, // 修改是否  需要上传补充资质 的checkbox选择
  onChangeMultiple: PropTypes.func, // 修改勾选多页
  failedCb: PropTypes.func, // 上传图片失败回调
}

export default IndustryDetail
